<template>
  <div class="card widget-card">

	<div v-if="title || headerButton || icon || $slots.header" class="widget-header" :class="{
			'header-click-enabled' : headerClickEnabled, 
			'body-hidden' : hideBody
		}"
		v-on:click="headerClick">

	  <h2 v-if="title || icon" class="widget-header">
		<i v-if="icon" class="fa header-icon" :class="icon"></i>
		{{title}}
		<i v-if="headerButton" class="fa header-button" :class="headerButton" v-on:click="headerButtonClick"></i>

		<!--<i
		  v-if="maxHeight && !expanded"
		  title="Expand widget to full height"
		  class="fa fa-expand header-button"
		  :class="{'offset-button':headerButton}"
		  v-on:click="expanded = true">
		</i>

		<i
		  v-else-if="maxHeight && expanded"
		  title="Collapse widget to default height"
		  class="fa fa-compress header-button"
		  :class="{'offset-button':headerButton}"
		  v-on:click="expanded = false">
		</i>-->


	  </h2>
	  <div class="header-slot">
		<slot name="header"></slot>
	  </div>
	</div>

	<div v-if="!noPadding && !hideBody" class="card-body" :class="{'max-height':maxHeight}" :style="{maxHeight: (maxHeight && !expanded) ? maxHeight : 'none'}">

	  <slot v-show="!widgetSpinner"></slot>

	  <spinner v-if="widgetSpinner" :inline="true"></spinner>

	</div>
	<slot v-else-if="!hideBody"></slot>

  </div>
</template>

<script>
import Spinner from "@/components/Spinner"
export default {

  name: 'Widget',
  components: {
	Spinner
  },
  props: ["title","icon","headerButton","noPadding","maxHeight","hideBody","widgetSpinner","headerClickEnabled"],
  data() {
	return {
	  expanded: false
	}
  },
  methods: {
	headerClick() {
	  if (this.headerClickEnabled)
		this.$emit("headerClick")
	},
	headerButtonClick() {
	  this.$emit("headerButtonClick")
	}
  }

}
</script>

<style type="text/css" scoped>

.widget-header.header-click-enabled {
  cursor: pointer;
}

.widget-header.header-click-enabled:hover {
  background-color: var(--brand-primary-color-faded);
}

.header-button {
  position: absolute;
  right: 10px;
  font-size: 16pt;
  cursor: pointer;
}

.header-button:hover {
  opacity: 0.6;
}

.header-icon {
  position: relative;
  top: 2px;
  margin-right: 5px;
}

.offset-button {
  right: 45px;
}

.widget-card {
  margin-bottom: 15px;
  box-shadow: 0 3px 1px -2px gray;
}

.form .card-body, .row-padding .card-body {
  padding: 15px;
}

.widget-header {
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.widget-header.body-hidden {
	border-radius: 10px;
}

.widget-header h2 {
  font-size: 12pt;
  /*text-transform: uppercase;*/
  font-weight: 900;
  padding: 10px;
  margin-bottom: 0px;
  max-width: calc(100% - 50px);
}

.widget-card {
  box-shadow: none;
}

.card-body {
  padding: 8px;
  height: 100%;
  -webkit-flex: 1;
}

.card-body.max-height {
  overflow: auto;
}

.header-slot {
  margin: 5px;
}

@media (max-width: 550px) {
  .widget-card {
	margin-left: -15px;
	margin-right: -15px;
  }
}
</style>